
import { LockDec, ValidateDec } from '@/decorators'
import { Component, Prop, Vue } from 'vue-facing-decorator'

@Component({})
export default class extends Vue {
  /** 当前要改的 SKU 行 */
  @Prop()
  modelValue: any

  /** popover 给的关闭方法，改完要主动收起 */
  @Prop()
  hideEvent: any

  postData = {
    price: '',
  }

  submitLoading = false;

  get skuTitle() {
    return this.modelValue?.name ? `（${this.modelValue.name}）` : '';
  }

  created() {
    this.postData.price = this.modelValue.price;
  }

  /** 规则和后端 GoodsSkuPriceOperatDto 对齐：非负、最多两位小数 */
  validatePrice(v) {
    if (v === '' || v === null || v === undefined) throw '请输入价格';
    if (!/^\d*(\.\d{0,2})?$/.test(String(v))) throw '价格最多两位小数';
    if (Number(v) < 0) throw '价格不能小于0';
    if (Number(v) > 99999999) throw '价格超出范围';
  }

  @LockDec('submitLoading')
  @ValidateDec('form')
  async confirm() {
    /** 价格是直接覆盖，不做增减，所以传绝对值就行 */
    await this.$postNotify('/manager/goods/price-operat', {
      id: this.modelValue.id,
      price: Number(this.postData.price),
    })
    /** 改完直接收起整个 popover，不用再看列表 */
    if (this.hideEvent) this.hideEvent();
    this.$emit('success');
  }

  /** 取消只是退回 SKU 列表，不关 popover */
  cancel() {
    this.$emit('back');
  }
}
